import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/home/grade/cx.png'
import _imports_1 from '@/assets/home/grade/lx.png'
import _imports_2 from '@/assets/home/grade/qy.png'
import _imports_3 from '@/assets/home/grade/ch.png'
import _imports_4 from '@/assets/home/grade/ISO27001.png'
import _imports_5 from '@/assets/home/grade/ISOIEC20000.png'
import _imports_6 from '@/assets/home/grade/shouhou.png'
import _imports_7 from '@/assets/home/grade/xinyong.png'
import _imports_8 from '@/assets/home/grade/huanjing.png'
import _imports_9 from '@/assets/home/grade/jiankang.png'
import _imports_10 from '@/assets/home/grade/zhiliang.png'
import _imports_11 from '@/assets/home/grade/lianhehui.png'
import _imports_12 from '@/assets/home/grade/yidengjiang.png'
import _imports_13 from '@/assets/home/grade/chanquan.png'
import _imports_14 from '@/assets/home/zs/software1.png'
import _imports_15 from '@/assets/home/zs/software2.png'
import _imports_16 from '@/assets/home/zs/CMMI5.png'
import _imports_17 from '@/assets/home/zs/CS2.png'
import _imports_18 from '@/assets/home/zs/zhuanjing.png'
import _imports_19 from '@/assets/home/zs/gaoxin.png'
import _imports_20 from '@/assets/home/zs/xinjishu.png'
import _imports_21 from '@/assets/home/zs/kexue.png'
import _imports_22 from '@/assets/home/zs/wurenji.png'


const _hoisted_1 = { class: "fullpage" }
const _hoisted_2 = { class: "fp-item fubg3" }
const _hoisted_3 = { class: "fp-item-cont" }

import { onMounted } from 'vue';
import { useHead } from '@vueuse/head'

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

useHead({
      title: '北京大象科技有限公司官网',
      meta: [
        { name: 'description', content: '北京大象科技有限公司多年来致力于研发全球领先的数字化仿真系统和服务，业务范围由轨道交通逐步拓展至低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率。'},
        { name: 'keywords', content:"轨道运营、地铁、铁路、低空、应急、培训、竞赛、实训基地、北京大象、大象科技、北京大象科技有限公司、北京大象科技有限公司官网"}
      ]
    })
    // const optionList = [
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    // ]
    onMounted(()=>{
      var element = document.getElementById('myElement');
      element.scrollTop = 0;
    })

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"fp-item fubg1\" data-v-2f033273><div class=\"fp-item-cont\" data-v-2f033273><div class=\"slogan\" data-v-2f033273><h3 data-v-2f033273>大象科技</h3><span data-v-2f033273>致力于研发全球领先的仿真系统和服务</span></div></div></div><div class=\"fp-item fubg2\" data-v-2f033273><div class=\"fp-item-cont\" data-v-2f033273><div class=\"fenleititle\" style=\"visibility:hidden;\" data-v-2f033273>公司简介</div><div class=\"gy_content\" data-v-2f033273><div class=\"aboutus\" style=\"visibility:hidden;\" data-v-2f033273><p class=\"article\" data-v-2f033273>北京大象科技有限公司成立于2013年，拥有国家高新技术企业、北京市首批&quot;专精特新&quot;中小企业、仿真培训领域唯一家交通运输部职业建设联系点、教育部双师型教师培训基地、北京低空产业联盟成员、AOPA 民用无人机驾驶员训练机构等资质。</p><p class=\"article\" data-v-2f033273>公司多年来致力于研发全球领先的数字化仿真系统和服务，业务范围由轨道交通逐步拓展至低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率。服务行业企业用户300+家，业务覆盖国内20余个省份、香港特别行政区以及海外3个国家。</p><p class=\"article\" data-v-2f033273>公司拥有一支团结、奋进、精研的高水平技术团队作为整个公司技术创新的强力引擎，承担复杂技术难题攻关任务，持续输出高品质技术成果。目前共拥有 4 项省部级科学进步奖，40项权威认证检测报告，44 项专利，270 项软著。</p></div></div></div></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "fenleititle",
          style: {"visibility":"hidden"}
        }, "公司资质", -1)),
        _createVNode(_component_el_carousel, {
          class: "carousel1",
          "indicator-position": "outside",
          height: "380px",
          autoplay: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", {
                  class: "certificate",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_0 }),
                    _createElementVNode("span", null, "诚信经营示范等级证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_1 }),
                    _createElementVNode("span", null, "立信单位等级证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_2 }),
                    _createElementVNode("span", null, "企业信用等级评价证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_3 }),
                    _createElementVNode("span", null, "重合同守信用等级证书")
                  ])
                ], -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", {
                  class: "certificate",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_4 }),
                    _createElementVNode("span", null, "ISO27001证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_5 }),
                    _createElementVNode("span", null, "ISOIEC 20000证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_6 }),
                    _createElementVNode("span", null, "五星级售后服务认证证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_7 }),
                    _createElementVNode("span", null, "供应商信用认证")
                  ])
                ], -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("div", {
                  class: "certificate",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_8 }),
                    _createElementVNode("span", null, "环境管理体系认证证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_9 }),
                    _createElementVNode("span", null, "职业健康安全管理体系认证证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_10 }),
                    _createElementVNode("span", null, "质量管理体系认证证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_11 }),
                    _createElementVNode("span", null, "中国电子信息行业联合会证书")
                  ])
                ], -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", {
                  class: "certificate",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_12 }),
                    _createElementVNode("span", null, "城市轨道交通科学进步一等奖")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_13 }),
                    _createElementVNode("span", null, "知识产权管理体系认证证书")
                  ])
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"certificate_mobile\" data-v-2f033273><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_0 + "\" data-v-2f033273><span data-v-2f033273>诚信经营示范等级证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_1 + "\" data-v-2f033273><span data-v-2f033273>立信单位等级证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_2 + "\" data-v-2f033273><span data-v-2f033273>企业信用等级评价证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_3 + "\" data-v-2f033273><span data-v-2f033273>重合同守信用等级证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_4 + "\" data-v-2f033273><span data-v-2f033273>ISO27001证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_5 + "\" data-v-2f033273><span data-v-2f033273>ISOIEC 20000证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_6 + "\" data-v-2f033273><span data-v-2f033273>五星级售后服务认证证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_7 + "\" data-v-2f033273><span data-v-2f033273>供应商信用认证</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_8 + "\" data-v-2f033273><span data-v-2f033273>环境管理体系认证证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_9 + "\" data-v-2f033273><span data-v-2f033273>职业健康安全管理体系认证证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_10 + "\" data-v-2f033273><span data-v-2f033273>质量管理体系认证证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_11 + "\" data-v-2f033273><span data-v-2f033273>中国电子信息行业联合会证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_12 + "\" data-v-2f033273><span data-v-2f033273>城市轨道交通科学进步一等奖</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_13 + "\" data-v-2f033273><span data-v-2f033273>知识产权管理体系认证证书</span></div></div>", 1)),
        _createVNode(_component_el_carousel, {
          class: "carousel2",
          "indicator-position": "outside",
          height: "300px",
          autoplay: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", {
                  class: "certificate2",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_14 }),
                    _createElementVNode("span", null, "软件企业证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_15 }),
                    _createElementVNode("span", null, "软件企业证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_16 }),
                    _createElementVNode("span", null, "CMMI5")
                  ])
                ], -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("div", {
                  class: "certificate2",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_17 }),
                    _createElementVNode("span", null, "CS2证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_18 }),
                    _createElementVNode("span", null, "北京市“专精特新”中小企业证书")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_19 }),
                    _createElementVNode("span", null, "高新技术企业证书")
                  ])
                ], -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_carousel_item, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("div", {
                  class: "certificate2",
                  style: {"visibility":"hidden"}
                }, [
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_20 }),
                    _createElementVNode("span", null, "新技术新产品证书-城市轨道交通全自动运行系统全场景仿真平台")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_21 }),
                    _createElementVNode("span", null, "北京市轨道交通学会科学技术进步奖二等奖")
                  ]),
                  _createElementVNode("div", { class: "detailpic" }, [
                    _createElementVNode("img", { src: _imports_22 }),
                    _createElementVNode("span", null, "民用无人机驾驶员训练机构合格证")
                  ])
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"certificate_mobile\" style=\"margin-top:50px;\" data-v-2f033273><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_14 + "\" data-v-2f033273><span data-v-2f033273>软件企业证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_15 + "\" data-v-2f033273><span data-v-2f033273>软件企业证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_16 + "\" data-v-2f033273><span data-v-2f033273>CMMI5</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_17 + "\" data-v-2f033273><span data-v-2f033273>CS2证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_18 + "\" data-v-2f033273><span data-v-2f033273>北京市“专精特新”中小企业证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_19 + "\" data-v-2f033273><span data-v-2f033273>高新技术企业证书</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_20 + "\" data-v-2f033273><span data-v-2f033273>新技术新产品证书-城市轨道交通全自动运行系统全场景仿真平台</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_21 + "\" data-v-2f033273><span data-v-2f033273>北京市轨道交通学会科学技术进步奖二等奖</span></div><div class=\"detailpic\" data-v-2f033273><img src=\"" + _imports_22 + "\" data-v-2f033273><span data-v-2f033273>民用无人机驾驶员训练机构合格证</span></div></div>", 1))
      ])
    ])
  ]))
}
}

})